// src/components/InvoiceCreator/CustomFields.tsx
import React from "react";
import { Input, Button, Space } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import styles from "./CustomFields.module.css";

export interface CustomField {
	id: string;
	label: string;
	value: string;
}

interface CustomFieldsProps {
	customFields: CustomField[];
	setCustomFields: React.Dispatch<React.SetStateAction<CustomField[]>>;
	labelField?: string;
	disabled?: boolean;
}

const CustomFields: React.FC<CustomFieldsProps> = ({ customFields, setCustomFields, labelField, disabled }) => {
	const addCustomField = () => {
		setCustomFields([...customFields, { id: Date.now().toString(), label: labelField ? labelField : "Custom Field", value: "" }]);
	};

	const updateCustomField = (id: string, field: "label" | "value", value: string) => {
		setCustomFields(customFields.map((cf) => (cf.id === id ? { ...cf, [field]: value } : cf)));
	};

	const removeCustomField = (id: string) => {
		setCustomFields(customFields.filter((cf) => cf.id !== id));
	};

	return (
		<div>
			{customFields.map((field) => (
				<div key={field.id} className={styles.customFieldRow}>
					<Input
						placeholder="Label"
						value={field.label}
						onChange={(e) => updateCustomField(field.id, "label", e.target.value)}
						className={styles.customFieldLabel}
						disabled={disabled}
					/>
					<Input
						placeholder="Value"
						value={field.value}
						onChange={(e) => updateCustomField(field.id, "value", e.target.value)}
						className={styles.customFieldValue}
						disabled={disabled}
					/>
					<Button
						type="text"
						danger
						icon={<DeleteOutlined />}
						onClick={() => removeCustomField(field.id)}
						className={styles.customFieldDelete}
					/>
				</div>
			))}

			<Button type="dashed" onClick={addCustomField} icon={<PlusOutlined />}>
				Add {labelField ? labelField : "Custom Field"}
			</Button>
		</div>
	);
};

export default CustomFields;
